import Player from './Player';
import SwitchBox from './SwitchBox';
import Ladder from './Ladder';
import FloorSwitchBox from './FloorSwitchBox';

function addEntities(scene) {
  scene.player = new Player({
    y: (scene.bottomEnter) ? scene.mainCanvas.height : -scene.mainCanvas.height,
    height: 30,
    scene,
  });

  scene.switchBox = new SwitchBox({
    y: 5,
    x: scene.mainCanvas.width / 2.4,
    scene,
  });

  scene.ladder = new Ladder({
    y: -scene.mainCanvas.height,
    scene,
  });

  scene.floorSwitchBox = new FloorSwitchBox({ x: -50, y: 18, scene });

  const ladderOffset = (scene.bottomEnter) ? 45 : 35;

  const ladders = new Array(5).fill(0).map((value, index) => (
    new Ladder({
      y: -scene.mainCanvas.height + ladderOffset + (10 * index),
      scene,
    })
  ));

  scene.entities = [
    ...ladders,
    scene.switchBox,
    scene.player,
    scene.floorSwitchBox,
  ];
}

export default addEntities;
